import { FC, memo } from 'react';

import { FormattedMessage } from 'react-intl';

import { Dialog } from './Dialog';
import { IModalProps } from './modal.interface';

/** Translated compatibility adapter; new layouts can compose Dialog directly. */
const Modal: FC<IModalProps> = memo(
  ({
    children,
    modalTitle,
    modalText,
    valueTitle,
    handleClose,
    btnClose = true,
    showCloseButton,
    ...props
  }) => (
    <Dialog
      {...props}
      onClose={handleClose}
      showCloseButton={showCloseButton ?? btnClose}
      title={
        modalTitle ? (
          <FormattedMessage id={modalTitle} values={{ valueTitle }} />
        ) : undefined
      }
      description={modalText ? <FormattedMessage id={modalText} /> : props.description}
    >
      {children}
    </Dialog>
  ),
);

export { Modal };
